import React, { useState, useEffect } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import './NegationsTest.css';

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru';

const ITEM_LABELS = {
  goat: 'коза', olen: 'олень', bear: 'медведь', squarel: 'белка',
  rain: 'дождь', misty: 'туман', sunny: 'солнце', snow: 'снег',
  bowl: 'миска', fork: 'вилка', big_cup: 'чашка', tea_pot: 'чайник',
  apple: 'яблоко', lemon: 'лимон', pear: 'груша', carrot: 'морковь',
  sit: 'сидит', run: 'бежит', stand: 'стоит', lay: 'лежит',
  cucumber: 'огурец', pumpkin: 'тыква',
};

const QUESTIONS_DATA = [
  {
    id: 1,
    question: 'Покажи животное, которое НЕ живёт в лесу', 
    correct: ['goat'],
    images: {
      olen: `${S3_BASE_URL}/vocabulary/olen.png`,
      goat: `${S3_BASE_URL}/vocabulary/goat.png`,
      bear: `${S3_BASE_URL}/vocabulary/bear.png`,
      squarel: `${S3_BASE_URL}/vocabulary/squarel.png`
    },
    options: ['goat', 'olen', 'bear', 'squarel']
  },
  {
    id: 2,
    question: 'Покажи картинки, где НЕ идет дождь',
    correct: ['misty', 'sunny', 'snow'], 
    images: {
      rain: `${S3_BASE_URL}/vocabulary/rain.png`, 
      sunny: `${S3_BASE_URL}/vocabulary/sunny.png`,
      snow: `${S3_BASE_URL}/vocabulary/snow.png`,
      misty: `${S3_BASE_URL}/vocabulary/misty.png`
    },
    options: ['rain', 'misty', 'sunny', 'snow']
  },
  {
    id: 3,
    question: 'Покажи предметы, которые не нужны для чаепития', 
    correct: ['bowl', 'fork'],
    images: {
      bowl: `${S3_BASE_URL}/vocabulary/bowl.png`,
      fork: `${S3_BASE_URL}/vocabulary/fork.png`,
      big_cup: `${S3_BASE_URL}/vocabulary/big_cup.png`,
      tea_pot: `${S3_BASE_URL}/vocabulary/tea_pot.png`
    },
    options: ['bowl', 'fork', 'tea_pot', 'big_cup']
  },
  {
    id: 4,
    question: 'Выбери всё, что НЕ является фруктом', 
    correct: [ 'carrot'],
    images: {
      apple: `${S3_BASE_URL}/vocabulary/apple.png`,
      lemon: `${S3_BASE_URL}/vocabulary/lemon.png`,
      pear: `${S3_BASE_URL}/vocabulary/pear.png`,
      carrot: `${S3_BASE_URL}/vocabulary/carrot.png`
    },
    options: ['apple', 'lemon', 'carrot', 'pear']
  },
  {
    id: 5,
    question: 'Выбери всех, кто НЕ движется', 
    correct: ['sit', 'stand', 'lay'],
    images: {
      sit: `${S3_BASE_URL}/vocabulary/sit.png`,
      run: `${S3_BASE_URL}/vocabulary/run.png`,
      stand: `${S3_BASE_URL}/vocabulary/stand.png`,
      lay: `${S3_BASE_URL}/vocabulary/lay.png`
    },
    options: ['stand', 'run', 'sit', 'lay']
  },
  {
    id: 6,
    question: 'Выбери фрукт, который НЕ красный', 
    correct: ['pear'],
    images: {
      apple: `${S3_BASE_URL}/vocabulary/apple.png`,
      pear: `${S3_BASE_URL}/vocabulary/pear.png`,
      cucumber: `${S3_BASE_URL}/vocabulary/cucumber.png`,
      pumpkin: `${S3_BASE_URL}/vocabulary/pumpkin.png`
    },
    options: ['apple', 'pear', 'cucumber', 'pumpkin']
  }
];

const NegationsTest = ({ onBack, onComplete }) => {
  const { play: playInstruction, stop: stopInstruction } = useInstructionAudio();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [answerLog, setAnswerLog] = useState([]);
  const [selected, setSelected] = useState([]); 
  const [showResult, setShowResult] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [shuffledOptions, setShuffledOptions] = useState([]);

  const shuffleArray = (arr) => {
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const questions = QUESTIONS_DATA;
  const totalQuestions = questions.length;
  const currentQuestion = questions[currentIndex];

  useEffect(() => {
    if (currentQuestion && shuffledOptions.length === 0) {
      setShuffledOptions(shuffleArray(currentQuestion.options));
    }
  }, [currentIndex, currentQuestion, shuffledOptions.length]);

  // ===== ОЗВУЧКА ВОПРОСА =====
  useEffect(() => {
    if (currentQuestion?.question) {
      playInstruction(currentQuestion.question);
    }
  }, [currentIndex, currentQuestion?.question]);

  // ===== НОВАЯ ФУНКЦИЯ: ПОВТОР ИНСТРУКЦИИ =====
  const repeatInstruction = () => {
    if (!currentQuestion?.question) return;
    stopInstruction();
    playInstruction(currentQuestion.question);
  };

  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => {
        const correctCount = answers.filter((a) => a === true).length;
        const score = Math.round((correctCount / totalQuestions) * 100);

        const failedQuestions = answerLog
          .filter(a => !a.isCorrect)
          .map(a => ({ question: a.question, missing: a.missing, extra: a.extra }));

        if (onComplete) {
          onComplete({
            testId: 'NegationsTest',
            score,
            details: { total: totalQuestions, correct: correctCount, failedQuestions },
          });
        } else {
          onBack();
        }
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showResult, answers, answerLog, totalQuestions, onComplete, onBack]);

  const goToNext = () => {
    setIsProcessing(true);
    setTimeout(() => {
      setShuffledOptions([]); 
      if (currentIndex < totalQuestions - 1) {
        setCurrentIndex(currentIndex + 1);
        setSelected([]);
      } else {
        setShowResult(true);
      }
      setIsProcessing(false);
    }, 600);
  };

  const handleSelect = (option) => {
    if (isProcessing) return;

    let newSelected;
    if (selected.includes(option)) {
      newSelected = selected.filter((item) => item !== option);
    } else {
      newSelected = [...selected, option];
    }
    setSelected(newSelected);
  };

  const handleConfirm = () => {
    if (isProcessing || selected.length === 0) return;

    const correct = currentQuestion.correct;
    const isCorrect = selected.length === correct.length && 
                      selected.every((item) => correct.includes(item));

    const missing = correct.filter(c => !selected.includes(c)).map(c => ITEM_LABELS[c] || c);
    const extra = selected.filter(c => !correct.includes(c)).map(c => ITEM_LABELS[c] || c);

    setAnswers([...answers, isCorrect]);
    setAnswerLog(prev => [...prev, { question: currentQuestion.question, isCorrect, missing, extra }]);
    goToNext();
  };

  if (showResult) {
    const correctCount = answers.filter((a) => a === true).length;
    return (
      
       <ModuleTemplate
      progress={answers}
      totalQuestions={totalQuestions}
      forceStop={true} 
      onComplete={onComplete || onBack}      
      onRepeat={repeatInstruction}
    >

        <div className="negation-result-content">
          <h2 className="negation-result-title">🎉 Упражнение завершено!</h2>
          <div className="negation-result-score">
            <span className="negation-score-number">{correctCount}</span>
            <span className="negation-score-total"> / {totalQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  if (!currentQuestion) {
    return (
      <ModuleTemplate 
        progress={[]} 
        totalQuestions={1} 
        forceStop={true}
        onComplete={onComplete || onBack}
      >
        <div className="negation-loading-text">Загрузка...</div>
      </ModuleTemplate>
    );
  }

  const displayOptions = shuffledOptions.length > 0 ? shuffledOptions : currentQuestion.options;

  return (
    <ModuleTemplate
      progress={answers}
      totalQuestions={totalQuestions}
      forceStop={true} 
      onComplete={onComplete || onBack}      
      onRepeat={repeatInstruction} 
      extraButtons={
        <button 
          className="negation-confirm-btn" 
          onClick={handleConfirm} 
          disabled={selected.length === 0}
        >
          ОК
        </button>
      }   
    >
      <div className="negation-container">
        <div className="negation-images-grid">
          {displayOptions.map((key) => {
            const isSelected = selected.includes(key);
            return (
              <button
                key={key}
                className={`negation-image-btn ${isSelected ? 'selected' : ''}`}
                onClick={() => handleSelect(key)}
              >
                <img
                  src={currentQuestion.images[key]}
                  alt=""
                  className="negation-image"
                  onError={(e) => { e.target.src = '/placeholder.png'; }}
                />
              </button>
            );
          })}
        </div>
        
        {/* Кнопка ОК теперь стандартная, а не плавающая. Она не сломает верстку на телефонах */}
       
      </div>
    </ModuleTemplate>
  );
};

export default NegationsTest;